// @ts-nocheck
import psHttp, {RequestConfig, PsResponse} from '@patsnap/common-ps-http';
import {
    EditTypes,
    ImageV3Info,
    hasInfoChanged,
    ThumbInfo,
} from '../../../image-loader-v3/src/utils/utils';
import get from 'lodash/get';
// @ts-ignore
import localStorageMemory from 'localstorage-memory';
import cloneDeep from 'lodash/cloneDeep';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
// @ts-ignore
import { CORE_SEARCH_SERVICE_URI } from '../../../../config/apiConfig';

const StorageAdapter:Storage = localStorageMemory;


function req(conf: RequestConfig) {
    return psHttp(conf).then(preValidation)
}
type originalFields = {
    "type"?: string,
    "original_code"?: string,
    "original_text"?: string,
}
interface Info extends originalFields {
    'new_id'?: string,
    "imageId": string,
    "coordinates": [number, number, number, number],
    "code": string,
    "text": string
}

export interface IParts {
    id: string;
    text: string;
    code: string;
    default: string;
    representive_label_txt: string;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    coordinates: [number, number, number, number];
    type: string;
    original_text?: string;
    original_code?: string;
    lang_to_text: {
        [key: string]: string
    }
}

enum StoreStrategy {
    ADD = 'add',
    RESET = 'reset',
    DELETE = 'delete',
    FILTEROUT = 'filterOut',
}



// 方便全清 在：analytics-patent-view/src/utils/figure.js
const storeKeys:Set<string> = new Set();
export function clearStoredAllMarks() {
    storeKeys.forEach(function (storeKey) {
        sessionStorage.removeItem(storeKey)
    })
}

export default class ChangeService {
    patentId: string
    imageUrl: string
    editType?: EditTypes
    info?: Info
    private _id?: string
    storeStrategy: StoreStrategy
    lastError: Error|undefined

    static editTypesSet = new Set([EditTypes.CUSTOM, EditTypes.PART_MODIFY])
    targetElementSelector: string
    private catchError: (err) => void;

    static getStoreNamespace(editType: EditTypes = EditTypes.CUSTOM, imageUrl: string) {
        let key = editType === EditTypes.CUSTOM ? `savedMarkings: ${imageUrl}` : `savedMarkings: PART`
        storeKeys.add(key);
        return key;
    }

    constructor(patentId, imageUrl) {
        this.patentId = patentId
        this.imageUrl = imageUrl
        this.storeStrategy = StoreStrategy.ADD;

        this.targetElementSelector = '.text-figure__box_index_9999'

        this.lastError = undefined

        this.catchError = (err) => {
            this.lastError = err;
            throw err;
        }
    }

    getIsCellOnImage() {return true;}

    get originals() {
        return {
            type: get(this, 'info.type'),
            code: get(this, 'info.original_code') || get(this, 'info.code'),
            text: get(this, 'info.original_text') || get(this, 'info.text'),
        }
    }

    get isResetAble(){
        return this.editType === EditTypes.PART_MODIFY
            && hasInfoChanged(this.info)
    }

    get id(): string {
        return this._id || get(this, 'info.id')
    }

    set id(str) {
        this._id = str
    }

    get errorMsg():string {
        return get(this, 'lastError.message') || get(this, 'lastError.numeric_error_code') || get(this, 'lastError.error_message')
    }

    getPayload() {
        if (!this.info) {
            throw new TypeError('LayerService info not defined!')
        }
        if (this.editType === EditTypes.CUSTOM) {
            return {
                id: this.id,
                "image_id": this.info.imageId,
                "patent_id": this.patentId,
                "url": this.imageUrl,
                "box": [0,0,1,1],
                "coordinates": this.info.coordinates,
                "code": this.info.code,
                "text": this.info.text
            }
        } else {
            return {
                id: this.info.new_id || this.id,
                "code": this.info.code,
                "text": this.info.text
            }
        }
    }

    async send(): Promise<void> {
        const self = this;
        self.lastError = undefined;
        if(!self.getIsCellOnImage()) {
            this.catchError(new Error('error_not_on_image'))
        }
        const payload = self.getPayload()
        if(!payload.text) {
            this.catchError(new Error('error_tag_empty'))
        }
        if (!this.id) {
            const data = await req({
                url: `${CORE_SEARCH_SERVICE_URI}/core-search-api/search/figure/custom`,
                method: 'post',
                data: payload
            }).catch(this.catchError)
            // 不要容错，不对就要挂。不然会造成数据混乱
            self.id = data.id;
        } else {
            await req({
                url: `${CORE_SEARCH_SERVICE_URI}/core-search-api/search/figure/detail`,
                method: 'put',
                data: payload
            }).catch(this.catchError)
            this.storeStrategy = StoreStrategy.ADD
        }
    }

    async delete(): Promise<void> {
        this.lastError = undefined;
        await req({
            url: `${CORE_SEARCH_SERVICE_URI}/core-search-api/search/figure/detail`,
            method: 'delete',
            data: this.getPayload()
        }).catch(this.catchError)

        this.storeStrategy = this.editType === EditTypes.CUSTOM ? StoreStrategy.DELETE : StoreStrategy.FILTEROUT
    }

    async reset(): Promise<void> {
        this.lastError = undefined;
        await req({
            cache: false,
            url: `${CORE_SEARCH_SERVICE_URI}/core-search-api/search/figure/detail/reset`,
            method: 'delete',
            data: {
                id: this.info?.new_id || this.id
            }
        }).catch(this.catchError)
        this.storeStrategy = StoreStrategy.RESET
    }

    get thumbInfo(): ThumbInfo {
        if (!this.info || (!this.id && !this.info.new_id)) {
            throw new TypeError('LayerService, id not defined')
        }
        return {
            id: this.id,
            new_id: this.info.new_id || this.id,
            editType: this.editType || undefined,
            // @ts-ignore
            type: this.info.type,
            "coordinates": this.info.coordinates,
            "code": this.info.code,
            "text": this.info.text
        }
    }

    sync2local(): void {
        if (this.storeStrategy === StoreStrategy.DELETE) {
            this.storeMarks(this.thumbInfo, true)
        } else if(this.storeStrategy === StoreStrategy.FILTEROUT) {
            this.storeMarks({
                ...this.thumbInfo,
                deleted: true
            })
        } else if(this.storeStrategy === StoreStrategy.RESET) {
            this.storeMarks({
                ...this.thumbInfo,
                ...this.originals,
                deleted: false
            })
        }else {
            this.storeMarks(this.thumbInfo)
        }
    }

    storeMarks(thumbInfo?: ThumbInfo, needDelete: Boolean = false): { [key: string]: ThumbInfo|boolean } {
        const storeKey = ChangeService.getStoreNamespace(this.editType, this.imageUrl);
        if (thumbInfo && thumbInfo.new_id) {
            let savedMarkings = this.storeMarks();

            const {new_id, code, text} = thumbInfo;
            if (needDelete) {
                savedMarkings[new_id] = false;
            } else if (!code && !text) {
                delete savedMarkings[new_id];
            } else {
                savedMarkings[new_id] = {...thumbInfo};
            }
            StorageAdapter.setItem(storeKey, JSON.stringify(savedMarkings));
            return savedMarkings
        } else {
            return ChangeService.readMarks(storeKey)
        }
    }
    static readMarks(storeKey:string): { [key: string]: ThumbInfo } {
        return JSON.parse(StorageAdapter.getItem(storeKey) || '{}');
    }
}


function preValidation(resp: PsResponse<any>) {
    const status: boolean = resp.data.status;
    if (status) {
        return resp.data.data
    } else {
        throw (resp.data.data || resp.data)
    }
}

export function figurePostprocess(_imgInfo:ImageV3Info): ImageV3Info {
    if(!(_imgInfo && _imgInfo.src)) {
        return _imgInfo
    }

    const image4Figures = _imgInfo.src;
    const storeKey1 = ChangeService.getStoreNamespace(EditTypes.PART_MODIFY, image4Figures)
    const storeKey2 = ChangeService.getStoreNamespace(EditTypes.CUSTOM, image4Figures);
    const savedMarks = {...ChangeService.readMarks(storeKey1),...ChangeService.readMarks(storeKey2)}
    const imgInfo = {..._imgInfo};
    const notAppliedKeys = new Set(Object.keys(savedMarks));
    function partEditMap(_item) {
        const item = cloneDeep(_item);
        const id = item.type === EditTypes.CUSTOM ? item.id : item.new_id;
        if (id in savedMarks) {
            if(!savedMarks[id]) {
                return null
            }
            const savedOb = savedMarks[id]
            item.type = savedOb.type;
            item.editType = savedOb.editType
            item.deleted = savedOb.deleted

            if(savedOb.editType === EditTypes.PART_MODIFY && !item.original_text && !item.original_code) {
                item.original_text = item.text;
                item.original_code = item.code;
            }

            item.code = savedOb.code;
            item.text = savedOb.text;
            item.coordinates = item.coordinates || savedOb.coordinates;



            notAppliedKeys.delete(id);
        }
        // 来源于请求
        if(item.original_text && (item.original_text !== item.text || item.original_code !== item.code)) {
            Object.assign(item, {
                editType : EditTypes.PART_MODIFY,
                // 2023.7.28 先注释掉，解决修改后的标签无法联动的问题
                // id: item.new_id
            })
        }
        if(item.type === EditTypes.CUSTOM) {
            Object.assign(item, {editType : EditTypes.CUSTOM})
        }

        return item;
    }
    const figs = {...(imgInfo.figure || {})};
    figs.fig ? figs.fig = figs.fig.map(partEditMap) : null;
    figs.parts ? figs.parts = figs.parts.map(partEditMap) : null;
    figs.fig = compact(figs.fig);
    figs.parts = compact(figs.parts);

    const customParts:Array<ThumbInfo> = [];
    notAppliedKeys.forEach(function (id) {
        const savedPart = {...savedMarks[id]} as ThumbInfo;
        if (savedPart.editType === EditTypes.CUSTOM) {
            customParts.push({
                id,
                type: savedPart.type || EditTypes.CUSTOM,
                editType: savedPart.editType,
                code: savedPart.code,
                deleted: savedPart.deleted,
                text: savedPart.text,
                coordinates: savedPart.coordinates,
            });
        }
    });
    figs.parts = figs.parts.concat(customParts)
    imgInfo.figure = figs;
    return imgInfo;
}

// 预处理parts中根据语言选择文本的函数
export function getFigurePartText(imageInfo: ImageV3Info, lang: string) {
    // 为了不改变函数参数中的原始数据，这里做一次深拷贝
    const _imageInfo = cloneDeep(imageInfo);
    const figure = get(imageInfo, 'figure', {});
    if (isEmpty(figure)) {
        return _imageInfo;
    }
    const parts = get(figure, 'parts', []);
    if (parts.length) {
        parts.forEach((part:IParts) => {
            const labelLang = lang || part.default;
            const langToText = get(part, 'lang_to_text', {});
            const defaultText = get(langToText, part.default, part.text);
            // 用户修改过后的text不会被覆盖
            if ((!part.original_code && !part.original_text)/* || part.original_text === part.text*/) {
                part.text = get(langToText, labelLang, defaultText);
            } else {
                // 当用户reset时，页面上的标签显示为original_text,因此这里要先替换一下
                part.original_text = get(langToText, labelLang, defaultText);
            }
        });
    }
    _imageInfo.figure = {
        ...figure,
        parts
    }
    return _imageInfo;
}
